<template>
  <div v-if="show" class="popup error-msg">
    <div class="popup-content p-4">
      <!-- メッセージ部分 -->
      <div
        class="confirmation-message text-center mx-auto mb-4 p-3 rounded border border-danger"
      >
        <p class="mb-1 fw-semibold text-danger">
          チャットルームを一括削除します。
        </p>
        <p class="mb-0 text-secondary">実施してよろしいですか？</p>
      </div>
      <div class="justify-content-center">
        <div class="popup-buttons gap-4">
          <button
            @click="onDelete"
            class="btn bg-gradient-danger white-text mb-0"
          >
            <i class="fas fa-trash-alt me-1"></i>削除する
          </button>
          <button
            @click="onClose"
            class="btn bg-gradient-secondary white-text mb-0"
          >
            <i class="fas fa-times me-1"></i>閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDeleteBotPopup',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onDelete() {
      this.$emit('delete')
    },
  },
}
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.popup-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 600px;
}

.popup-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.badge {
  text-transform: none !important;
}

.badge-danger {
  word-break: break-word; /* or break-all */
  white-space: normal;
}

.confirmation-message {
  max-width: 420px;
  box-shadow: 0 0 10px rgba(220, 53, 69, 0.25);
}
</style>
